<template>
  <article>
    <section id="top-company" class="gongsijianjie">
      <div class="wrapper">
        <div class="subhead">
          <span>公司简介</span>
        </div>
        <!-- 公司简介 begin -->
        <div class="p1-box">
          <div class="pure-g">
            <div class="pure-u-1 pure-u-xl-1-2">
              <div class="history">
                <div class="history-box" v-for="(item, index) in swiperList" :key="index">
                  <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" oncontextmenu="return false;" />
                </div>
              </div>
            </div>
            <div class="pure-u-1 pure-u-xl-2-5">
              <!-- <div style="text-align: center;font-size: 30px;margin-top: 30px;">河南嗨浪技术有限公司</div> -->
              <p style="margin-top:10px;line-height:30px" v-html="companyList[0].content"></p>
            </div>
          </div>
        </div>
        <div id="videoContant" style="text-align: center;margin-top: 20px;">
          <video controls muted loop style="width: 100%;">
            <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/49d8c88ac823da1f87223334ec5fd23b.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </section>
    <!-- 公司简介 end -->

    <!-- 公司团队 begin -->
    <section id="top-staff" class="employee">
      <div class="subhead">
        <span>公司团队</span>
      </div>
      <div class="p1-box">
        <!-- @click="$router.push('/profile/staff')" -->
        <div ref="mySwiper" v-swiper:mySwiper="swiperOption" class="swiper-container ygfc-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in staffList" :key="index">
              <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl"
                style="width: 350px;height: 250px;" oncontextmenu="return false;">
              <!-- <p
                style="height: 50px;line-height: 50px;background: rgba(0, 0, 0, 0.4);position: relative;margin-top: -50px;color: #ffffff;text-align: center;">
                {{ item.twoType }}</p> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 公司团队 end -->

    <!-- 办公环境 begin -->
    <!-- <section id="top-office" class="bghj">
      <div class="wrapper">
        <div class="subhead">
          <span>办公环境</span>
        </div>
        <div class="p1-box">
          <swiper ref="bangongSwiper" class="swiper" :options="swiperOption1">
            <swiper-slide>
              <img class="pure-img" src="../assets/environment/0.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" src="../assets/environment/1.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" style="width:383px;height:230px;" src="../assets/environment/2.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" style="width:383px;height:230px;" src="../assets/environment/3.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" style="width:383px;height:230px;" src="../assets/environment/4.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" style="width:383px;height:230px;" src="../assets/environment/5.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" src="../assets/environment/6.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" src="../assets/environment/7.jpg">
            </swiper-slide>
            <swiper-slide>
              <img class="pure-img" src="../assets/environment/8.jpg">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section> -->
    <!-- 办公环境 end -->

    <!-- 业务版图 -->
    <section id="profile-one">
      <div class="wrapper">
        <div class="subhead">
          <span>业务版图</span>
        </div>
        <section id="top-company">
          <div class="wrapper" style="margin-left: 15px;line-height: 30px;" v-html="businessLayout[0].imageContent"></div>
        </section>
        <div class="p1-box" style="display: block; justify-content: center;">
          <img :src="'https://himifi.cn/api/admin/getImage?path=' + businessLayout[0].imageUrl" />
        </div>
      </div>
    </section>
    <!-- 业务版图 end -->
  </article>
</template>

<script>
// import Header from '@/components/header/header'
// import TreeChart from "vue-tree-chart";
// import TreeChart from "@/components/TreeChart.vue";
export default {
  name: "Profile",
  data() {
    return {
      swiperList: [],
      companyList: [], // 公司简介
      staffList: [], //公司团队
      businessLayout: [],// 业务版图
      isMobile: document.body.clientWidth < 1280 ? true : false,
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        loop: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 20
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30
          },
          1440: {  //当屏幕宽度大于等于1440
            slidesPerView: 4,
            spaceBetween: 30
          },
          1920: {  //当屏幕宽度大于等于1920
            slidesPerView: 5,
            spaceBetween: 10
          }
        }
      },
      curLunbo: 4,
      swiperOption1: {
        slidesPerView: document.body.clientWidth < 1280 ? 2 : 3,
        spaceBetween: 10,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    // 公司团队
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    bangongSwiper() {
      return this.$refs.bangongSwiper.$swiper
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = document.body.clientWidth < 1280 ? true : false;
    });
  },
  created() {
    // 公司简介、公司团队
    this.team()
  },
  methods: {
    moveLeftSlide() {
      this.bangongSwiper.slidePrev()
    },
    moveRightSlide() {
      this.bangongSwiper.slideNext()
    },
    // 公司简介、公司团队
    team() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "2"
      }, res => {
        this.swiperList = res.data.公司简介[1]
        setInterval(() => {
          this.curLunbo += 1
          if (this.curLunbo >= this.swiperList.length) {
            this.curLunbo = 0
          }
          this.swiperBrief.slideTo(this.curLunbo, 2000, false)
        }, 3000)
        this.companyList = res.data.公司简介[3]
        this.staffList = res.data.公司团队[1]
        this.businessLayout = res.data.业务版图[1]
      });
      setInterval(() => {
        this.curLunbo += 1
        if (this.curLunbo >= this.staffList.length) {
          this.curLunbo = 1
        }
        this.swiper.slideTo(this.curLunbo, 1000, false)
      }, 3000)
    }
  },
}
</script>

<style scoped>
@import "~@/assets/styles/profile.css";

.history {
  display: flex;
  flex-wrap: wrap;
}

.history-box {
  padding: 25px;
  text-align: center;
}

.history-box>img {
  width: 300px;
  height: 200px;
}
</style>
